import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import {
  BaseForm,
  BaseButton,
  BaseTextContent,
  XrkMessage,
  BaseDialog,
  BaseFormItem,
  BaseSelect
} from 'xrk-components';
import { getInvoiceItem, getInvoiceSubItem } from '../../data-source/apis';
import { GetInvoiceItemDataItem } from '../../data-source/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'add-category-dialog',
  props: {
    remove: {},
    invoiceItemIdList: {}
  },
  emits: ['success'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;
const props = __props;

const selectedIds1 = props.invoiceItemIdList.map(item => item.id);
const selectedIds2 = props.invoiceItemIdList.map(item => item.subItemId);

const invoiceBranch = {
  1: { ajax: getInvoiceItem, selectedIds: selectedIds1 },
  2: { ajax: getInvoiceSubItem, selectedIds: selectedIds2 }
};

const formRef = ref();
const formData = ref<GetInvoiceItemDataItem>({
  id: null,
  code: '',
  topLevelCategory: '',
  subcategory: '',
  label: '',
  value: null,
  disabled: false,
  subItemId: null,
  subItemName: null,
  name: null
});

const getInvoiceItemRemoteMethod = async (val: string, type: 1 | 2) => {
  const resp = await invoiceBranch[type].ajax({
    keyword: val,
    ...(formData.value.id && { itemId: formData.value.id }) // 获取二级数据
  });
  resp.data.forEach(item => {
    // 不可重复添加
    if (invoiceBranch[type].selectedIds.includes(item.id)) {
      item.disabled = true;
    }
  });
  return resp;
};

const onInvoiceItemChange = (val, [option]) => {
  formData.value = option;
};
const onSubItemChange = (val, [option]) => {
  Object.assign(formData.value, {
    subItemId: option.id,
    subItemName: option.name
  });
};
const onCancel = () => {
  props.remove();
};

const onConfirm = async () => {
  XrkMessage.success('操作成功');
  emits('success', formData.value);
  onCancel();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "650px",
    title: "新增类目",
    "model-value": true,
    "show-close": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false,
    "show-footer": false
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: onCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), {
        type: "primary",
        disabled: !formData.value.id || !formData.value.subItemId,
        click: onConfirm
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 保存 ")
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(BaseForm), {
            ref_key: "formRef",
            ref: formRef,
            "label-position": "right",
            model: formData.value
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BaseFormItem), {
                label: "一级类目",
                prop: "id",
                rules: [
            {
              required: true,
              trigger: 'change',
              message: '请选择'
            }
          ]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseSelect), {
                    placeholder: "请选择",
                    modelValue: formData.value.id,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.id) = $event)),
                    filterUseRemote: true,
                    init: true,
                    remoteMethod: val => getInvoiceItemRemoteMethod(val, 1),
                    onChange: onInvoiceItemChange
                  }, null, 8, ["modelValue", "remoteMethod"])
                ]),
                _: 1
              }),
              _createVNode(_unref(BaseFormItem), {
                label: "二级类目",
                prop: "subItemId",
                rules: [
            {
              required: true,
              trigger: 'change',
              message: '请选择'
            }
          ]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseSelect), {
                    placeholder: "请选择",
                    labelKey: "name",
                    valueKey: "id",
                    disabled: !formData.value.id,
                    filterUseRemote: true,
                    init: false,
                    remoteMethod: val => getInvoiceItemRemoteMethod(val, 2),
                    modelValue: formData.value.subItemId,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.subItemId) = $event)),
                    onChange: onSubItemChange
                  }, null, 8, ["disabled", "remoteMethod", "modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})